import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  // Habit Routes
  getHabits(date) {
    let url = buildUrl("habits/" + date)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getHabitStatistic(habit_id) {
    let url = buildUrl("habits/statistic/" + habit_id)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchWorkoutHabit(workoutId) {
    let url = buildUrl("user/training/workout/" + workoutId)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchGroupFitnessHabit(courseTimelineId) {
    let url = buildUrl("user/training/groupfitness/" + courseTimelineId)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateHabit(data) {
    let url = buildUrl("habit")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  executeHabit(execution) {
    let url = buildUrl("habit/execute")
    return axios.post(url, execution, buildOptions()).then((res) => res.data)
  },
  deleteHabit(habitId) {
    console.log(habitId)
    let url = buildUrl("habit/" + habitId)
    return axios.delete(url, buildOptions()).then((res) => res.data)
  },
}
